import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { connect } from 'react-redux';
import { getAllAlarmTemplatesWithIdProject } from 'services/api';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import Bouton from '../../../UI/Bouton/Bouton';

const TableauGabarit = (props) => {
  const [templateList, setTemplateList] = useState([]);
  const getTemplates = React.useCallback(async () => {
    try {
      const response = await getAllAlarmTemplatesWithIdProject({
        list_project_id: props.filtre_projects_list_id,
      });
      if (response.data.state) {
        setTemplateList(response.data.list_templates);
      }
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  }, [props.filtre_projects_list_id]);
  useEffect(() => {
    getTemplates();
  }, [getTemplates]);

  const tableConfig = {
    columns: [
      { dataField: 'template_id', text: checkMot('template_id'), sort: true },
      { dataField: 'project_id', text: checkMot('project_id'), sort: true },
      {
        dataField: 'template_name',
        text: checkMot('template_name'),
        sort: true,
      },
      { dataField: 'start', text: checkMot('start'), sort: true },
      { dataField: 'end', text: checkMot('end'), sort: true },
      { dataField: 'private', text: checkMot('private'), sort: true },
      { dataField: 'alarm_level', text: checkMot('alarm_level'), sort: true },
    ],
    list_templates: templateList,
    selectRow: {
      mode: 'radio',
      clickToSelect: true,
      style: {
        background: '#a6153e',
        color: 'white',
      },
      onSelect: (row, isSelect) => {
        if (isSelect) {
          return props.selectioneLigne(row);
        }
      },
    },
  };

  return templateList?.length > 0 ? (
    <BootstrapTable
      keyField={'template_id'}
      data={templateList}
      columns={tableConfig.columns}
      selectRow={tableConfig.selectRow}
    />
  ) : (
    <Bouton cliquer={() => getTemplates(props.filtre_projects_list_id)}>
      {checkMot('refresh')}
    </Bouton>
  );
};

const mapStateToProps = (state) => {
  return {
    filtre_projects_list_id: state.authentifie.filtre_projects_list_id,
  };
};

export default connect(mapStateToProps)(TableauGabarit);
